export default __webpack_public_path__ + "static/media/section3-bg3.20cc731a.png";